export interface Image {
    name?: any;
    path?: any;
    small?: string;
    medium?: string;
    large?: string;
    full?: string;
    source?: string;
}